/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForAzureCspSubscription extends models.ServiceAccountNativeDetailsBaseForAzureSubscription {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForAzureCspSubscription");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForAzureCspSubscription.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForAzureCspSubscription>): ServiceAccountNativeDetailsForAzureCspSubscription {
        let obj = Object.assign(new ServiceAccountNativeDetailsForAzureCspSubscription(), model);
        ServiceAccountNativeDetailsForAzureCspSubscription.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForAzureCspSubscription>): ServiceAccountNativeDetailsForAzureCspSubscription {
        if (!model) return null;
        return ServiceAccountNativeDetailsForAzureCspSubscription.newInstance(<ServiceAccountNativeDetailsForAzureCspSubscription> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForAzureCspSubscription) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForAzureCspSubscription.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForAzureCspSubscription): boolean {
        if (models.ServiceAccountNativeDetailsBaseForAzureSubscription.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForAzureCspSubscription.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Offer Type of the Subscription
     */
    offer_type: string;

}
